<div id="map">
    <!-- Adicione o formulário dentro da div do mapa -->
    <form>
        <input type="text" placeholder="Digite a placa" (input)="atualizarPlacaFiltrada($event)"
            [(ngModel)]="placaFiltrada">
    </form>
</div>

